import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=11e8bd9d&scoped=true&"
import script from "./VideoPreview.vue?vue&type=script&lang=ts&"
export * from "./VideoPreview.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=11e8bd9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e8bd9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
